import { useParams } from "react-router-dom";
import { MedicalInfoTab } from "./medical-info-tab";

export function MedicalInfoTabRoute() {
  const { tabId } = useParams<{ tabId: string }>();
  return <MedicalInfoTab tabId={tabId ?? "diagnosis"} />;
}
